import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from '../../shared/shared.service';
import { ApiService } from '../../core/services/api/api.service';
import { HelperService } from '../../core/services/api/helper.service';
import { Apollo } from 'apollo-angular';
import { GraphQlService } from '../../core/services/api/graphql.service';
import { DOCUMENT } from "@angular/common";
import { DataLayerService } from '@core/services/seo/data-layer.service';
import { ContentfulService } from '@core/services/cms/contentful.service';
import { select, Store } from '@ngrx/store';

import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';
import { MongoDbService } from '@core/services/api/mongodb.service';
import { IMongoProduct } from '@core/models/catalog';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit, OnDestroy {

  allHeroEntries= {};
  allSubcategories= {};
  hero: any;
  query: any;

  screenWidth: any;

  public subscription: Subscription[] = [];
  private productsSubscription: Subscription;
  public productBrandsSubscription: Subscription
  public productQuerySubscription: Subscription
  public productCategoriesSubscription: Subscription
  public productDecorationSubscription: Subscription
  public loading: boolean = true; // Vallue turns to false when the data has loaded from the API -- front end should check when this is false to show the product cards

  public products: IMongoProduct[];
  
  public brands: any
  public brand: any;
  
  public categories: any
  public category: string = '';

  public decorations: any
  public decorationType: string = '';

  public custom: string = '';


  public search;
  public searchInputParam: string = ''
  
  public destroyed = new Subject<void>()
  public viewport
 
  public gql: any;
  public count: number = 0

  public mongo: any;

  public nextToken: string = "";
  public limit: number

  public variables: any
  windowScrolled: boolean

  isLoading: boolean = false;

  mongoParam: any
  catalogCategoriesFilterSubscription: Subscription;
  categoriesFilter: any[];

  constructor(
    protected api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private helper: HelperService,
    protected bp: BreakpointObserver,
    private shared: SharedService,
    private apollo: Apollo,   
    private _graphQl: GraphQlService,
    private _mongo: MongoDbService,
    private dataLayerService: DataLayerService,
    private contentfulService: ContentfulService,
    private store: Store,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) this.dataLayerService.logPageView(event.url);
    })
    bp.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
    Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).pipe(takeUntil(this.destroyed)).subscribe(result => {
      for(const query of Object.keys(result.breakpoints)){
        if(result.breakpoints[query]){
          this.viewport = this.shared.displayNameMap.get(query)
        }
      }
    })
    }
    
    ngOnInit(): void {
        this.screenWidth = window.innerWidth;
    
        this.mongoGetProducts()
        this.getBrands()
        this.getCategories()
        this.getDecoration()

  }
 
  /* UI/UX LOGIC start */
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }

  /* UI/UX LOGIC end */

  /**
   * Method that will filter the products based on the filter
   * Will also update the query params in the url
   * @param item Object {key: 'brand', item: 'Addidas'} 
   */
  filterProducts(item:Object){
    console.log('filter this item', item)
    let main = item['key']
    let valueParam = item['item']

    // const queryParams = this.formatQueryParams(main, valueParam)
    const queryParams = { [main]: valueParam }

    console.log('query params', queryParams)
    this.contentfulService.getHeroEntries()
    .then((response) => {
        response.forEach((category) => {
          this.allHeroEntries[category.fields.heroCategoryName] = category.sys.id;
        });

        if(Boolean(valueParam)) {
          for (const [key, value] of Object.entries(this.allHeroEntries)) {
            if(key == valueParam) {
              this.store.pipe(select(fromCatalog.selectHero(key))).subscribe((hero => { this.hero = hero }));
            } else {
              this.hero = null;
            }
          }
        }
    });

    this.search = ''
    this.brand = ''
    this.category = ''
    this.nextToken = ''
    this.custom = ''
    this.decorationType = ''

    this.mongoParam = [queryParams]
    this.store.dispatch(CatalogActions.updateCatalogQuery(
      {
        queryUpdate: this.mongoParam,
        currentPage: 1,
        sort: 'A-Z'
      }
    ));

    this.store.dispatch(CatalogActions.getCatalogProducts(
      {
        searchParam: this.mongoParam,
        currentPage: 1,
        sort:'A-Z'
      }
    ));
    

    this.store.pipe(select(fromCatalog.selectProducts)).subscribe((products => { this.products = products }));

    this.router.navigate(['catalog/all'], {
      queryParams: queryParams,
      
    })
    
  }

  /**
   * Select brands from NGRX store for main nav in the catalog
   */
  protected getBrands(){
    this.productBrandsSubscription =
      this.store.pipe(select(fromCatalog.selectBrandsNav)).subscribe((brands) => {
        this.brands = brands
      });
    this.subscription.push(this.productBrandsSubscription); // Store the subscription for cleanup
  }

   /**
   * Mongo endpoint to get the products from the specific category
   */
    protected mongoGetProducts(){
      this.products = this.mongo;
    }

  /**
   * Select categories from NGRX store for main nav in the catalog
   */
  protected getCategories(){
    this.productCategoriesSubscription = this.store.pipe(select(fromCatalog.selectCategoriesNav)).subscribe((categories) => {
      this.categories = categories

    });    
    this.subscription.push(this.productCategoriesSubscription); // Store the subscription for cleanup
  }

  protected getDecoration(){
    this.decorations = [
      'Sublimation',
      'Branded Merchandise',
      'Embroidery',
      'Dye & Wash',
      'Woven / Patch',
      'Laser',
      'On Demand',
      'Transfer',
      'Print'
    ]
  }

  formatProductsMongo(search, brand, category, decorationType) {
    let mongoParam = [];
  
    if (search) {
      let searchQuery = {}
      mongoParam.push(searchQuery);
    }
  
    if (brand) {
      let brandQuery = {'brand' : brand}
      mongoParam.push(brandQuery);
    }
  
    if (category) {
      let categoryQuery = {'categories': category}
      mongoParam.push(categoryQuery);
    }
    
    if (decorationType) {
      let decorationQuery = {}
      mongoParam.push(decorationQuery);
    }

    return mongoParam;
  }
  



    /**
   * Unsubscribe subscriptions to avoid any memory leaks
   */
     ngOnDestroy(): void {
      this.subscription.forEach((subscription) => subscription.unsubscribe())
  }

}